// Button IDs are qualified by their owning menu. Never infer node type from ID length.
export function permissionTree(nodes) {
  return nodes.filter(node => node.menuLevel !== 3).map(node => {
    const buttons = node.btnList || (node.subList || []).filter(child => child.menuLevel === 3);
    return {
      ...node, type: 1,
      subList: [...permissionTree(node.subList || []), ...buttons.map(button => ({
        ...button, keyId: node.keyId + "_" + button.keyId, sourceId: button.keyId,
        parentKeyId: node.keyId, type: 2, subList: []
      }))]
    };
  });
}
export function checkedLeaves(nodes, granted) {
  const keys = new Set(granted), result = [];
  function visit(items) {
    items.forEach(node => {
      // Parent checks must not automatically grant newly added buttons.
      if (!node.subList.length && keys.has(node.keyId)) result.push(node.keyId);
      visit(node.subList);
    });
  }
  visit(nodes);
  return result;
}
export function permissionDetails(checked, halfChecked) {
  return [...checked.map(node => ({ node, halfType: 1 })), ...halfChecked.map(node => ({ node, halfType: 2 }))]
    .map(({ node, halfType }) => ({ keyId: node.sourceId || node.keyId, type: node.type, parentKeyId: node.parentKeyId || "", halfType }));
}
